/* eslint-disable */
"use strict";

var search = (function () {
    var advancedCriteria = [];

    var $form = $('.search-form');
    var $formLoading = $('.loading-img');
    var $btnAdvanced = $form.find('#btn-advanced-search');
    var $filtersAdvanced = $form.find('#filters-advanced-search');
    var $filterLabels = $form.find('#advanced-filter-labels');
    var moreVisible = false;

    function init() {
        if ($form.length > 0) {
            _bindEvents();
            _init();
            _initPagination();
            _showAdvancedLabels();
            _initPopulate();
        }
    }

    function _initPopulate() {
        $('span.my').text('My');
        $(":input").inputmask();
        $("#phone").inputmask({
            mask: '999 999 9999',
            placeholder: ' ',
            showMaskOnHover: false,
            showMaskOnFocus: false,
            onBeforePaste: function (pastedValue, opts) {
                var processedValue = pastedValue;
                return processedValue;
            }
        });
    }

    function _initPagination() {
        var $pagination = $('ul.pagination');
        var baseUrl = $pagination.attr('data-url');

        var $links = $pagination.find('a');
        $links.each(function () {
            var pieces = baseUrl.split('?');
            var pageUrl = pieces[0] + $(this).attr('data-page');
            if(pieces.length > 1) {
                pageUrl += '?' + pieces[1];
            }

            $(this).attr('href', pageUrl);
        })

        var $active = $pagination.find('li.active a').first();
        var $prev = $pagination.find('li.prev a').first();
        var $next = $pagination.find('li.next a').first();
        if ($active.length > 0 && parseInt($active.html()) > 0) {
            var pageNum = parseInt($active.html());
            var $nextPage = $pagination.find('li a[data-page=' + (pageNum + 1) + ']').first();
            if ($nextPage.length > 0) {
                $next.parent().css('visibility', 'visible');
            }

            var $prevPage = $pagination.find('li a[data-page=' + (pageNum - 1) + ']').first();
            if ($prevPage.length > 0) {
                $prev.parent().css('visibility', 'visible');
            }
        }
    }

    function _bindEvents() {
        $form.submit(function () {
            _search();

            return false;
        });
 
        $btnAdvanced.click(function() {
            $filtersAdvanced.toggle('fast');
        });

        $('#more-options-btn').click(function() {
            var label = $(this).find('span');
            var container = $('#more-options');
            var newLabel = moreVisible ? '[+]' : '[-]';
            label.text(newLabel);
            container.toggle('fast');
            moreVisible = !moreVisible;
        });
    }

    function _showAdvancedLabels() {
        var business = $filtersAdvanced.find('#business').first().val();
        if(business && business.length > 0) {
            advancedCriteria.push({
                'name': 'Business Type',
                'value': 'business'
            });
        }

        var ethnicity = $filtersAdvanced.find('#ethnicity:checked');
        if(ethnicity && ethnicity.length > 0) {
            advancedCriteria.push({
                'name': 'Ethnicity (' + ethnicity.length + ')',
                'value': 'ethnicity'
            });
        }

        var availability = $filtersAdvanced.find('#availability:checked');
        if(availability && availability.length > 0) {
            advancedCriteria.push({
                'name': 'Availability (' + availability.length + ')',
                'value': 'availability'
            });
        }


        if(advancedCriteria.length > 0) {
            var x = '<span class="remove">&#10005;</span>';
            for(var i=0; i<advancedCriteria.length; i++) {
                var $el = $('<a>')
                    .attr('class', 'label label-default')
                    .html(advancedCriteria[i].name + x)
                    .attr('data', advancedCriteria[i].value);

                $el.click(function() {
                    var id = $(this).attr('data');
                    if(id === 'ethnicity') {
                        $filtersAdvanced.find('input[name=ethnicity]').attr('checked', false);
                    }
                    else if(id === 'availability') {
                        $filtersAdvanced.find('input[name=availability]').attr('checked', false);
                    }
                    else if(id === 'business') {
                        $filtersAdvanced.find('#business').val('');
                    }

                    _search()
                });

                $filterLabels.append($el);
            }
        }
    };

    function _init() {
        $('.selectpicker').selectpicker();
        if(current_city && current_city.length > 0) {
            $('.selectpicker').selectpicker('val', current_city);
        }

        $formLoading.hide();
        $form.fadeIn('fast');
    };

    function _search() {
        var hostname = $form.attr('data-host');
        var protocol = window.location.protocol + '//';
        var path = '/' + (window.adSlug || 'female-escorts') + '/';
        var query = [];
        var hasCity = false;

        var ethnicity = [];
        var availability = [];

        $form.find('input,select').each(function () {
            var inputName = jQuery(this).attr('name');
            var inputVal = jQuery(this).val();

            if (typeof(inputName) != 'undefined' && inputVal.length > 0) {
                if (inputName == 'city') {
                    hasCity = true;
                    hostname = inputVal + '.' + hostname;
                }
                else if(inputName == 'keywords' && inputVal.length > 0) {
                    path += 'search/' + inputVal + '/';
                }
                else if(inputName == 'ethnicity') {
                    var isChecked = jQuery(this).is(':checked');
                    if(isChecked) {
                        ethnicity.push(inputVal);
                    }
                }
                else if(inputName == 'availability') {
                    var isChecked = jQuery(this).is(':checked');
                    if(isChecked) {
                        availability.push(inputVal);
                    }
                }
                else {
                    query.push(inputName + '=' + inputVal);
                }
            }
        });

        if(ethnicity.length > 0) {
            query.push('ethnicity=' + ethnicity.join(','));
        }

        if(availability.length > 0) {
            query.push('availability=' + availability.join(','));
        }

        if(query.length > 0) {
            query = '?' + query.join('&');
        }

        var url = protocol + hostname + path + query;

        if(!hasCity) {
            $form.find('#city-required-alert').removeClass('hidden');
        }
        else {
            window.location = url;
        }
    }

    return {
        init: init
    }
})();

search.init();